// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TabGroup {
    static getAttributeTypeMap() {
        return TabGroup.attributeTypeMap;
    }
}
TabGroup.discriminator = undefined;
TabGroup.additionalProperties = false;
TabGroup.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "tabs",
        "baseName": "tabs",
        "type": ""
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
];
//# sourceMappingURL=tabGroup.js.map